import {AuthStore} from "../service/auth/auth.store";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";


/**
 * Initializer to fetch the logged in user as the app initializes
 *
 * actions suchs as refresh page using ctrl+r or from the refresh button at top of client makes app to reinitialize
 * which leads us to lose the logged in user from state. This initializer fetches the logged in user as the app initializes
 *
 * @param authStore
 */
/*export const fetchSessionUser = function (authStore: AuthStore) {
    return ()=> authStore.fetchSessionUser();
}*/

export const fetchSessionUser = function (authStore: AuthStore): () => Observable<void> {
    return () => authStore.fetchSessionUser().pipe(
        map(() => void 0) // Muutetaan tulos void-tyyppiseksi
    );
};